// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-arrival-report.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-arrival-report/flight-plan-arrival-report.js';

mount([g0]);
